<template>
  <div
    class="unavailable-container"
  >
    <DpplPng
      :file-name="imgName"
      class="faded-chart"
    />
    <span class="unavailable-text mb-3">
      <slot />
    </span>
  </div>
</template>

<script setup>
import DpplPng from '../datapeople/DpplPng.vue';

defineProps({
  imgName: {
    type: String,
    required: true,
  },
});
</script>

<style scoped lang="less">
.unavailable-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  position: relative;

  .faded-chart {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .unavailable-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    z-index: 2;
    max-width: 345px;
    text-align: center;
  }

  :deep(a) {
    color: @text-brand;
  }
}
</style>
